module.exports = __webpack_public_path__ + "img/linkedin.65446561.png";